import { useStyletron } from 'baseui';

const useStyles = () => {
	const [css] = useStyletron();
	const disabledStyle = css({ cursor: 'not-allowed', opacity: 0.75 });
	const containerStyle = css({
		display: 'flex',
		padding: '2px',
		justifyContent: 'flex-start',
		gap: '10px',
		alignItems: 'center',
		minHeight: '44px',
		border: '2px solid rgb(238, 238, 238)',
		backgroundColor: 'rgb(238, 238, 238)'
	});

	const inputStyle = css({ display: 'none' });

	const imageContainerStyle = css({
		backgroundColor: '#ffffff',
		display: 'flex',
		flexWrap: 'wrap',
		gap: '10px',
		alignItems: 'center',
		padding: '2px'
	});

	const fileContainerStyle = css({ gap: '10px', display: 'flex' });

	const imageStyle = css({ maxHeight: '200', maxWidth: '100%' });

	const iconActiveStyle = css({ cursor: 'pointer' });

	const downloadFileContainerStyle = css({ cursor: 'pointer' });

	return {
		disabledStyle,
		containerStyle,
		inputStyle,
		imageContainerStyle,
		imageStyle,
		iconActiveStyle,
		fileContainerStyle,
		downloadFileContainerStyle
	};
};

export default useStyles;
